import dynamic from 'next/dynamic';

export const RSBrandModal = dynamic(() => import('./RSBrandModal').then(module => module.default));
